//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('contentRemoveFiltersEmptyState', {
    bindings: {
      startOverCallback: '&',
    },
    template: require('@legacy-components/content/content-remove-filters-empty-state.html'),
  });
})();
